import React, { useState } from "react";

interface VideoContainerProps {
  videoSrc: string;
  videoType?: string;
  description?: string;
  className?: string;
  thumbnailSrc?: string;
}

const VideoContainer: React.FC<VideoContainerProps> = ({
  videoSrc,
  videoType = "video/mp4",
  description,
  className = "",
  thumbnailSrc,
}) => {
  const [showVideo, setShowVideo] = useState(!thumbnailSrc);

  return (
    <div className="rounded-3xl my-16" >
      <div
        className={`md:w-[75%] px-4 w-full container lg:mx-auto  ${className}`}
      >
        {/* Video Container with Glow Effect */}
        <div className="relative">
          <div className="absolute inset-0 bg-purple-400 rounded-lg sm:rounded-xl blur-xl opacity-10 transform scale-105"></div>
          <div
            className="relative w-full bg-white rounded-lg sm:rounded-xl overflow-hidden"
            style={{
              aspectRatio: '16/9',
              boxShadow: '0 4px 20px rgba(128, 90, 213, 0.15)'
            }}
          >
            {!showVideo && thumbnailSrc ? (
              <div className="relative w-full h-full">
                <img
                  src={thumbnailSrc}
                  alt={description || "Video thumbnail"}
                  className="w-full h-full object-cover"
                />
                <button
                  className="absolute inset-0 w-full h-full flex items-center justify-center bg-black bg-opacity-20 hover:bg-opacity-30 transition-opacity"
                  onClick={() => setShowVideo(true)}
                >
                  <div className="w-16 h-16 bg-white bg-opacity-80 rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-purple-600 ml-1">
                      <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
                    </svg>
                  </div>
                </button>
              </div>
            ) : (
              <iframe
                src={videoSrc}
                className="w-full h-full object-contain"
                frameBorder="0"
                allowFullScreen
                title={description || "Video content"}
              ></iframe>
            )}
          </div>
        </div>


      </div>
    </div>
  );
};

export default VideoContainer;